module.exports = __webpack_public_path__ + "static/media/hero-hyperwallet-2.c299d258.png";